<template>
  <div class="default-layout">
    <div
      id="viewport"
      class="w-100 relative"
    >
      <shopping-cart />
    </div>
  </div>
</template>
<script>
import ShoppingCart from '../components/ShoppingCart.vue';

export default {
    components: {
        ShoppingCart
    },
}
</script>
